import { useMemo, useState } from "react";
import "./PriceFilter.css";
import { useTranslation } from "react-i18next";

const histogramData = [
  2, 4, 8, 12, 18, 22, 20, 16, 24, 28, 18, 14, 30, 12, 18, 22, 15, 10, 18, 12,
  20, 15, 10, 17, 11, 9, 14, 13, 8, 11, 12, 10, 8, 9, 7, 8, 6, 5, 4, 5, 4, 3,
  4, 3, 2, 2, 1, 1
];

const MIN = 0;
const MAX = 10000;
const STEP = 100;

export default function PriceFilter({ minPrice, maxPrice, setMinPrice, setMaxPrice, totalCount }) {

  // percent calculations
  const minPercent = useMemo(
    () => ((minPrice - MIN) / (MAX - MIN)) * 100,
    [minPrice]
  );

  const maxPercent = useMemo(
    () => ((maxPrice - MIN) / (MAX - MIN)) * 100,
    [maxPrice]
  );

  const [openFilter, setOpenFilter] = useState(false);
  // handlers
  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxPrice - STEP);
    setMinPrice(value);
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minPrice + STEP);
    setMaxPrice(value);
  };

  const clearAll = () => {
    setMinPrice(0);
    setMaxPrice(10000);
  };

  const { t } = useTranslation();
  return (
    <div onMouseLeave={() => setOpenFilter(false)}>
      <div className="bedrooms-dropdown" onClick={() => setOpenFilter((prev) => !prev)}>
        {t("Price")}
        {openFilter ? (
          <i className="fa">&#xf106;</i>   // 🔼 up arrow
        ) : (
          <i className="fa">&#xf107;</i>   // 🔽 down arrow
        )}
      </div>
      <div className="price-filter-card" style={{ display: openFilter ? "block" : "none" }}>
        {/* <div className="box-show-hidden" onClick={() => setOpenFilter(false)}></div> */}
        {/* Top Price Boxes */}
        <div className="price-box-row">
          <div className="price-box">
            <span className="label"> {t("Min price")}</span>
            <div className="value">
              ${minPrice.toLocaleString()} <span>/mo</span>
            </div>
          </div>

          <div className="dash">–</div>

          <div className="price-box">
            <span className="label"> {t("Max price")}</span>
            <div className="value">
              ${maxPrice.toLocaleString()} <span>/mo</span>
            </div>
          </div>
        </div>

        {/* Histogram + Slider */}
        <div className="histogram-wrapper">
          <div className="histogram">
            {histogramData.map((bar, index) => {
              const percent = (index / histogramData.length) * 100;

              const isActive =
                percent >= minPercent && percent <= maxPercent;

              return (
                <div
                  key={index}
                  className={`bar ${isActive ? "active-bar" : ""}`}
                  style={{ height: `${bar * 4}px` }}
                />
              );
            })}
          </div>

          <div className="slider-wrapper">
            {/* grey track */}
            <div className="slider-track" />

            {/* pink selected range */}
            <div
              className="slider-range"
              style={{
                left: `${minPercent}%`,
                width: `${maxPercent - minPercent}%`
              }}
            />

            {/* inputs */}
            <input
              type="range"
              min={MIN}
              max={MAX}
              step={STEP}
              value={minPrice}
              onChange={handleMinChange}
              className="range-input"
            />

            <input
              type="range"
              min={MIN}
              max={MAX}
              step={STEP}
              value={maxPrice}
              onChange={handleMaxChange}
              className="range-input"
            />

            {/* thumbs */}
            <div
              className="thumb-display"
              style={{ left: `${minPercent}%` }}
            >
              ||
            </div>

            <div
              className="thumb-display"
              style={{ left: `${maxPercent}%` }}
            >
              ||
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="price-filter-footer">
          <button className="clear-btn" onClick={clearAll}>
            {t("Clear")}
          </button>
          <button onClick={() => setOpenFilter(false)} className="results-btn">{t("View")} {totalCount?.toLocaleString()} {t("results")}</button>
        </div>
      </div>
    </div>
  );
}